import React from "react";
import {
  Box,
  Button,
  InputLabel,
  Typography,
  CircularProgress,
  TextField,
} from "@mui/material";
import ImageIcon from "@mui/icons-material/Image";
import styled from "@emotion/styled";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

interface ImageUploadProps {
  imageUrl: string;
  imageUrlLink: string;
  fileName: string;
  loading: boolean;
  onFileChange: (e: any) => void;
  onUpload: () => void;
  onDelete: () => void;
  onImageUrlChange: (url: string) => void;
}

const ImageUpload: React.FC<ImageUploadProps> = ({
  imageUrl,
  imageUrlLink,
  fileName,
  loading,
  onFileChange,
  onUpload,
  onDelete,
  onImageUrlChange,
}) => {
  return (
    <Box sx={{ mt: 3 }}>
      <Box className="image-upload">
        <Box
          sx={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}>
          <Button
            component="label"
            variant="contained"
            size="small"
            startIcon={<ImageIcon />}
            disabled={imageUrl || imageUrlLink ? true : false}
            sx={{
              textTransform: "none",
              backgroundColor: "#4aa5dc",
              "&:hover": {
                backgroundColor: "#4aa5dc",
              },
              width: "140px",
            }}>
            Choose Image
            <VisuallyHiddenInput type="file" onChange={onFileChange} />
          </Button>

          <InputLabel sx={{ ml: 2, fontSize: "14px" }}>
            {imageUrl || imageUrlLink ? (
              <Box sx={{ display: "flex" }}>
                <img
                  src={imageUrl || imageUrlLink}
                  alt="Preview"
                  style={{
                    width: "200px",
                    height: "150px",
                    marginTop: "6px",
                    objectFit: "cover",
                  }}
                />
                <Typography
                  sx={{
                    cursor: "pointer",
                    ml: 1,
                    fontSize: "24px",
                  }}
                  onClick={onDelete}>
                  x
                </Typography>
              </Box>
            ) : (
              fileName
            )}
          </InputLabel>
        </Box>
        <Box>
          {loading ? (
            <CircularProgress size={40} sx={{ color: "#4aa5dc" }} />
          ) : (
            <Button
              variant="outlined"
              size="small"
              sx={{
                ml: 5,
                textTransform: "none",
                color: "#4aa5dc",
                padding: "4px 25px",
              }}
              disabled={imageUrlLink ? true : false}
              onClick={onUpload}>
              Upload Image
            </Button>
          )}
        </Box>
      </Box>
      <Typography sx={{ textAlign: "center", fontSize: "12px" }}>
        (OR)
      </Typography>
      <TextField
        fullWidth
        name="imageUrl"
        label="Image URL"
        value={imageUrlLink}
        onChange={(e) => onImageUrlChange(e.target.value)}
        margin="normal"
        disabled={imageUrl ? true : false}
      />
    </Box>
  );
};

export default ImageUpload;
